import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { FDLozenge, FDPaper, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';

export const UpgradeWidget = ({ resource }) => {
  const isMobile = useMobileLayout();
  const theme = useTheme();
  const rel = resource.withRelationship(
    fr.relationships.upgradeNow.name,
    (relation) => relation,
    () => null,
  );

  if (rel == null) {
    return null;
  }

  return (
    <FDPaper appearance={'flat'} flex={1} padding={3} minWidth={isMobile ? undefined : theme.dimensions.md}>
      <FDStack direction={'column'} spacing={1}>
        <FDLozenge
          color={'success'}
          label={resource.attr('offerHeadline')}
        />
        <MetaControlField attr={'offerDescription'} />
        <SecondaryActionButtonRel
          alignSelf={'flex-start'}
          relationship={rel}
          {...dataAttrs('tax-dashboard-upgrade')}
        />
      </FDStack>
    </FDPaper>
  );
};
